import { z } from 'zod';

import { messages } from './StepBackupEmailVerify.messages';

export const schema = z.object({
    emailVerificationCode: z.string().min(3, messages.errorEmailVerificationCodeRequired),
});
